export const getProductTranslationAttributes = (product, countries = []) => {
  // Build VAT object dynamically from all countries
  const vat = {};
  
  // If countries are provided, use them to build VAT object
  if (countries.length > 0) {
    countries.forEach((country) => {
      const countryCode = country.countryCode.toLowerCase();
      const fieldName = `vat_${countryCode}`;
      vat[countryCode] = product[fieldName] !== null && product[fieldName] !== undefined ? product[fieldName] : null;
    });
  } else {
    // Fallback: scan all product properties for vat_* fields
    Object.keys(product).forEach((key) => {
      if (key.startsWith('vat_')) {
        const countryCode = key.replace('vat_', '');
        vat[countryCode] = product[key] !== null && product[key] !== undefined ? product[key] : null;
      }
    });
  }
  
  return {
    name: {
      en: !!product.name ? product.name : null,
      nl: !!product.name_nl ? product.name_nl : null,
      fr: !!product.name_fr ? product.name_fr : null,
      de: !!product.name_de ? product.name_de : null,
    },
    description: {
      en: !!product.description ? product.description : null,
      nl: !!product.description_nl ? product.description_nl : null,
      fr: !!product.description_fr ? product.description_fr : null,
      de: !!product.description_de ? product.description_de : null,
    },
    shortDescription: {
      en: !!product.shortDescription ? product.shortDescription : null,
      nl: !!product.shortDescription_nl ? product.shortDescription_nl : null,
      fr: !!product.shortDescription_fr ? product.shortDescription_fr : null,
      de: !!product.shortDescription_de ? product.shortDescription_de : null,
    },
    category: {
      en: !!product.category ? product.category : null,
      nl: !!product.category_nl ? product.category_nl : null,
      fr: !!product.category_fr ? product.category_fr : null,
      de: !!product.category_de ? product.category_de : null,
    },
    attributes: {
      en: !!product.attributes ? product.attributes : null,
      nl: !!product.attributes_nl ? product.attributes_nl : null,
      fr: !!product.attributes_fr ? product.attributes_fr : null,
      de: !!product.attributes_de ? product.attributes_de : null,
    },
    vat,
    productName: product.name,
    productDescription: product.shortDescription,
    descriptionLong: product.description,
    productCategory: product.category,
    productAttributes: product.attributes,
  };
};

export const removeProductRedundantAttributes = (product) => {
  return new Promise((resolve, reject) => {
    delete product.name_nl;
    delete product.name_fr;
    delete product.name_de;
    delete product.description_nl;
    delete product.description_fr;
    delete product.description_de;
    delete product.shortDescription_nl;
    delete product.shortDescription_fr;
    delete product.shortDescription_de;
    delete product.category_nl;
    delete product.category_fr;
    delete product.category_de;
    delete product.attributes_nl;
    delete product.attributes_fr;
    delete product.attributes_de;
    
    // Dynamically remove all vat_* fields
    Object.keys(product).forEach((key) => {
      if (key.startsWith('vat_')) {
        delete product[key];
      }
    });
    
    resolve(product);
  });
};
